import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './PopUpWhatIsEsim.scss';
import { prepareNewWindowUrl } from '../../../../utilities/StringHelpers/StringHelpers';

const PopUpWhatIsEsim = (props) => {
  let listDescription = null;
  let title = "";
  let context = null;
  let url = "";

  if (props.contentData != null && props.contentData!=null) {
    listDescription = props.contentData?.esimData?.expandedValue[0].firstDescriptionEsimPopUp.value;
    title=props.contentData?.esimData?.expandedValue[0]?.whatIsEsimTitlePopUp?.value;
    context = props.context;
    url=props.contentData?.esimData?.expandedValue[0]?.cellularDevicesSupportedUrl?.value;
  }
  else {
    listDescription = props.iContent?.firstDescriptionEsimPopUp?.value;
    title=props.iContent?.whatIsEsimTitlePopUp?.value;
    context = props.props?.context;
    url = props.iContent.cellularDevicesSupportedUrl?.value;
  }

  return (
    <>
      {props.isPopUp ? (
        <>
          <div className='what-is-esim-container'>
            <h4 className='first-title-what-is-esim'>{title}</h4>
            <div className='what-is-esim-list'>
              {listDescription && listDescription?.map((e, i) => {
                return (<>
                  <li key={i}>
                    <span className='checkMarkIcon'>
                      <Image src={require('./Icons/icon-16-checkmark.svg')} />
                    </span>
                    <span>{e}</span>
                  </li>
                  {/* <br /> */}
                </>)
              })}
            </div>
            <a className='second-title-what-is-esim' onClick={() => prepareNewWindowUrl(url, context)}>
              האם המכשיר שלי תומך ב-eSIM?
            </a>
          </div>
          <div className='footer-pop-up-container'>
            {props.footerButton != null ? <div className='footerButton'>{props.footerButton}</div> : <></>}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default PopUpWhatIsEsim;
